<template>
  <v-tooltip top :disabled="disabled">
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on" v-bind="attrs">
        <slot />
      </div>
    </template>
    <span>
      {{ text }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: "ReviewBoosterItem",
  props: {
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
